import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  FormControl,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Autocomplete,
  Popper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
} from "@mui/material";
import { headingStyle, xBtn } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import // textfieldTextBlueBorder,
"../../style/AppointmentStyle";
import { textfieldTextBlueBorder } from "../../style/PatientDetailsStyle";
import AddIcon from "@mui/icons-material/Add";
import { textfieldTextBlueBr } from "../../style/PharmacyStyle";
import { orangeButton, primaryBtnTeal } from "../../style/PatientDetailsStyle";
import { showToast } from "../../utils/toastUtil";
import UseGetAllMedicineList from "../../helper/UseGetAllMedicineList";
import {
  autoFocusOffWithOutBorder,
  drTableGreen,
  drTableRowBlueBg,
} from "../../style/PatinetFormStyle";
import AddCardIcon from "@mui/icons-material/AddCard";
import UseFetchSupplierList from "../../helper/UseFetchSupplierList";
import UseFetchLabInventories from "../../helper/UseFetchLabInventories";
import UseFetchPackList from "../../helper/UseFetchPackList";
import { generatePurchaseOrder } from "../../connections/postApi";
import {
  menuItemStyle,
  selectField,
  textfieldTextBlueBorderPharmacy,
} from "../../style/AppointmentStyle";
import { putPurchaseOrder } from "../../connections/putApi";
import useDebounce from "../../hooks/UseDebounce";
import UseFetchMedicineAdmin from "../../helper/UseFetchMedicineAdmin";
import UseFetchMedicineDetailsAdmin from "../../helper/UseFetchMedicineDetailsAdmin";

const NewPurchaseOrder = ({ onClose, refetch }) => {
  // console.log(supplierData);

  const [supplierInput, setSupplierInput] = useState(null);
  const [confirmCloseOpen, setConfirmCloseOpen] = useState(false);

  const handleSupplierChange = (e) => {
    // console.log('working', e);
    e.preventDefault();
    setSupplierInput(e?.target?.value);
  };

  const debouncedInputSupplier = useDebounce(supplierInput, 500);

  const [medicineSearchInput, setMedicineSearchInput] = useState(null);
  //  console.log(medicineList?.payload?.medicines);
  const handleMedicineChange = (e) => {
    e.preventDefault();
    setMedicineSearchInput(e?.target?.value);
  };
  const debouncedInputMedicine = useDebounce(medicineSearchInput, 500);
  const { data: medicineList, isLoading: medicineLoading } =
    UseFetchMedicineAdmin(1, 10, debouncedInputMedicine);

  // const { data: medicineList } = UseGetAllMedicineList();
  const { data: supplierList, isLoading: supplierListLoading } =
    UseFetchSupplierList(1, 10, debouncedInputSupplier);
  const { data: labInventoriesList } = UseFetchLabInventories();
  const { data: packList } = UseFetchPackList();

  const [filteredMedicines, setFilteredMedicines] = useState([]);

  useEffect(() => {
    // Simulating fetching all data on component mount and storing it in local storage or state.
    // if (
    //   medicineList?.payload?.medicines &&
    //   medicineList?.payload?.medicines?.length > 0
    // ) {
    //   localStorage.setItem(
    //     "allMedicines",
    //     JSON.stringify(medicineList?.payload?.medicines)
    //   );
    // }

    // const medicinePrev = purchaseOrderArr?.map((item)=>
    //   id : item?.medicine?.id,
    // )
    setFilteredMedicines(medicineList?.payload?.medicines);
  }, [medicineList]);

  const [fieldOptions, setFieldOptions] = useState({
    // supplierList: JSON.parse(localStorage.getItem("supplierList")) || [],
    labInventoriesList:
      JSON.parse(localStorage.getItem("labInventoriesList")) || [],
    packList: JSON.parse(localStorage.getItem("packList")) || [],
  });

  const [formState, setFormState] = useState({
    // id:"",
    supplier_id: "",
    suppliers: "",
    purchase_date: new Date().toISOString().split("T")[0],
    bill_type: "",
    bill_number: "",
    grand_total: "",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [openMedicineList, setOpenMedicines] = useState(false);
  const [errors, setErrors] = useState({});
  const [purchaseOrderArr, setPurchaseOrderArr] = useState([
    // {
    //   medicine_id: "",
    //   medicine_name: '',
    //   pack: "",
    //   hsn_code: "",
    //   batch: "",
    //   expiry_date: "",
    //   quantity: "",
    //   cgst: "",
    //   sgst: "",
    //   rate: "",
    //   mrp: "",
    //   mfr: "",
    //   discount: "",
    //   amount: "",
    //   department_id: "9",
    // },
  ]);
  const [isSubmitting, setIsSubmitting] = useState(false); // it will prevent multiple api calls
  const [focus, setFocus] = useState(false);
  const [discountType, setDiscountType] = useState("rs");
  const [selectedMedicineId, setSelectedMedicineId] = useState(null);
  const [selectedMedicineIndex, setSelectedMedicineIndex] = useState(null);

  const { data: medicineDetails, isFetching: medicineDetailsLoading } =
    UseFetchMedicineDetailsAdmin(selectedMedicineId);

  useEffect(() => {
    if (!medicineDetails?.payload) return;
    console.log("Medicine Details:", medicineDetails);

    const detail = medicineDetails.payload;
    const hsnCode = detail.hsn_code || detail.hsn_name || "";
    const pack = detail.medicine_batches?.[0]?.packing || "";
    const batch = detail.medicine_batches?.[0]?.batch_no || "";

    if (selectedMedicineIndex !== null) {
      setPurchaseOrderArr((prev) => {
        const updated = [...prev];
        updated[selectedMedicineIndex] = {
          ...updated[selectedMedicineIndex],
          hsn_code: hsnCode,
          pack,
          // batch,
        };
        return updated;
      });
    }
  }, [medicineDetails]); // "rs" or "percent"
  const [loading, setLoading] = useState(false);
  const [highlightedIndexMedicine, setHighlightedIndexMedicine] = useState(0);
  const [purchaseOrderResponse, setPurchaseOrderResponse] = useState({});
  const [validateCorrectDeleteOrders, setValidateCorrectDeleteOrders] =
    useState({});

  // console.log(supplierData);
  // console.log(purchaseOrderArr);

  const handleSearch = (event) => {
    // console.log(event.target.value);
    const query = event.target.value.toLowerCase();
    setSearchTerm(query);
    const storedMedicines =
      JSON.parse(localStorage.getItem("allMedicines")) || [];

    // Filter medicines based on search query
    const filteredMedicineList = storedMedicines.filter((medicine) =>
      medicine[1].toLowerCase().startsWith(query),
    );

    // Limit the results to top 10 and sort
    let limitedResults = filteredMedicineList.slice(0, 10);
    if (!query) {
      limitedResults = [];
    }
    setFilteredMedicines(limitedResults);
  };

  useEffect(() => {
    if (supplierList?.payload?.suppliers?.length > 0) {
      // localStorage.setItem(
      //   "supplierList",
      //   JSON.stringify(supplierList.payload.suppliers)
      // );
      setFieldOptions((prev) => ({
        ...prev,
        supplierList: supplierList.payload.suppliers,
      }));
    }

    if (labInventoriesList?.payload?.lab_inventories?.length > 0) {
      localStorage.setItem(
        "labInventoriesList",
        JSON.stringify(labInventoriesList.payload.lab_inventories),
      );
      setFieldOptions((prev) => ({
        ...prev,
        labInventoriesList: labInventoriesList.payload.lab_inventories,
      }));
    }

    if (packList?.payload?.packing?.length > 0) {
      localStorage.setItem(
        "packList",
        JSON.stringify(packList.payload.packing),
      );
      setFieldOptions((prev) => ({
        ...prev,
        packList: packList.payload.packing,
      }));
    }
  }, [supplierList, labInventoriesList, packList]);

  //handle form change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);

    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({ ...prev, [name]: undefined }));
    // setErrors((prevErrors) => ({
    //   ...prevErrors,
    //   [name]: undefined,
    // }));
  };

  const updateNameAndId = (index, value) => {
    const newMedicines = [...purchaseOrderArr];
    newMedicines[index] = {
      ...newMedicines[index],
      medicine_id: value?.id,
      medicine_name: value?.name,
    };
    setFilteredMedicines([]);
    setPurchaseOrderArr(newMedicines);
  };

  const handleKeyDown = (e, index, field) => {
    if (field === "medicine_name") {
      if (["ArrowDown", "ArrowUp"].includes(e.key)) {
        e.preventDefault();
        // Navigate options with arrow keys
        setHighlightedIndexMedicine((prevIndex) => {
          if (e.key === "ArrowDown") {
            return prevIndex < filteredMedicines?.length - 1
              ? prevIndex + 1
              : 0;
          } else {
            return prevIndex > 0
              ? prevIndex - 1
              : filteredMedicines?.length - 1;
          }
        });
      } else if (e.key === "Tab") {
        if (!purchaseOrderArr[index]?.medicine_name) {
          setTimeout(() => document.getElementById(`submit`).focus(), 0);
          return;
        }

        e.preventDefault();
        const topOption = filteredMedicines[highlightedIndexMedicine];

        if (topOption) {
          // handleChange(index, "medicine_name", topOption[1]);
          // handleChange(index, "medicine_id", topOption[0]);

          // console.log(topOption, 'topOption')
          setHighlightedIndexMedicine(0);
          updateNameAndId(index, topOption);
          setTimeout(() => {
            document.getElementById(`pack-${index}`).focus();
          }, 0);
        }
        //  else {
        //   setHighlightedIndexMedicine(0);
        //   // setTimeout(
        //   //   () => document.getElementById(`-${index}`).focus(),
        //   //   0
        //   // ); // Focus next field
        // }
      } else if (e.key === "Enter") {
        if (!purchaseOrderArr[index]?.medicine_name) {
          setTimeout(() => document.getElementById(`submit`).focus(), 0);
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        const topOption = filteredMedicines[highlightedIndexMedicine];

        if (topOption) {
          // console.log(topOption, 'topOption')
          setTimeout(() => {
            setHighlightedIndexMedicine(0);
            updateNameAndId(index, topOption);
            setTimeout(() => {
              setHighlightedIndexMedicine(0);
              document.getElementById(`pack-${index}`).focus();
            }, 0);
          }, 100);
        } else {
          // console.log(topOption, 'topOption); in side else');
          // setHighlightedIndexMedicine(0);
          setTimeout(() => {
            document.getElementById(`pack-${index}`).focus();
          }, 0);
        }
      }
    }

    if (field === "pack" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`hsnCode-${index}`).focus(), 0);
    }

    if (field === "hsnCode" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`batch-${index}`).focus(), 0);
    }

    if (field === "batch" && e.key === "Enter") {
      setTimeout(
        () => document.getElementById(`expiry_date-${index}`).focus(),
        0,
      );
    }

    if (field === "expiry_date" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`quantity-${index}`).focus(), 0);
    }

    if (field === "quantity" && e.key === "Enter") {
      setTimeout(
        () => document.getElementById(`free_quantity-${index}`).focus(),
        0,
      );
    }

    if (field === "free_quantity" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`cgst-${index}`).focus(), 0);
    }

    if (field === "cgst" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`sgst-${index}`).focus(), 0);
    }

    if (field === "sgst" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`rate-${index}`).focus(), 0);
    }

    if (field === "rate" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`mrp-${index}`).focus(), 0);
    }

    if (field === "mrp" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`mfr-${index}`).focus(), 0);
    }

    if (field === "mfr" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`discount-${index}`).focus(), 0);
    }

    if (field === "discount" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`amount-${index}`).focus(), 0);
    }

    if (field === "amount" && e.key === "Enter") {
      if (purchaseOrderArr?.length > index + 1) {
        setTimeout(
          () => document.getElementById(`medicine_name-${index + 1}`).focus(),
          100,
        );
      } else {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`medicine_name-${index + 1}`).focus(),
          100,
        );
      }
    }

    // if (field === "department_id" && e.key === "Enter") {
    //   handleAddRow()
    //   setTimeout(() => document.getElementById(`medicine_name-${index + 1}`).focus(), 100)
    // }
  };

  const handleAddRow = () => {
    if (!isFormValid()) {
      const missing = [];
      if (!formState?.supplier_id) missing.push("Supplier Name");
      if (!formState?.bill_number) missing.push("Bill Number");
      if (!formState?.bill_type) missing.push("Bill Type");
      if (!formState?.purchase_date) missing.push("Purchase Date");
      showToast(`Please fill: ${missing.join(", ")}`, "ERROR");
      return;
    }

    if (purchaseOrderResponse?.id && purchaseOrderArr?.length > 0) {
      if (!isSubmitting) {
        handleUpdateOrder();
        setIsSubmitting(true);
      }
    }
    setPurchaseOrderArr((prev) => [
      ...prev, // Spread the existing rows
      {
        medicine_id: "",
        medicine_name: "",
        pack: "",
        hsn_code: "",
        batch: "",
        expiry_date: "",
        quantity: "",
        free_quantity: "",
        cgst: 2.5,
        sgst: 2.5,
        rate: "",
        mrp: "",
        mfr: "",
        discount: "",
        amount: "",
        department_id: "9",
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    setPurchaseOrderArr(
      (prev) => prev.filter((_, i) => i !== index), // Keep rows that don't match the index
    );
  };

  // const handleChange = (index, field, value) => {
  //   // console.log(index, field, value)
  //   const newPurchaseOrders = [...purchaseOrderArr];
  //   newPurchaseOrders[index] = { ...newPurchaseOrders[index], [field]: value };
  //   setPurchaseOrderArr(newPurchaseOrders);

  //   // setErrors((prevErrors) => ({
  //   //   ...prevErrors,
  //   //   [`purchaseOrder_${index}_${field}`]: undefined,
  //   // }));

  // };
  const handleChange = (index, field, value) => {
    const updatedOrderArr = [...purchaseOrderArr];

    if (field === "discount" && discountType === "percent") {
      // Store raw percent for display; compute flat for calculation
      const rate = parseFloat(updatedOrderArr[index].rate) || 0;
      const quantity = parseFloat(updatedOrderArr[index].quantity) || 0;
      const flatDiscount = (rate * quantity * (parseFloat(value) || 0)) / 100;
      updatedOrderArr[index] = {
        ...updatedOrderArr[index],
        discount_percent: value,
        discount: flatDiscount,
      };
    } else {
      updatedOrderArr[index] = { ...updatedOrderArr[index], [field]: value };
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      if (updatedErrors[`${field}_${index}`]) {
        delete updatedErrors[`${field}_${index}`];
      }

      if (
        ["rate", "discount", "quantity", "cgst", "sgst"].includes(field) &&
        updatedErrors[`amount_${index}`]
      ) {
        delete updatedErrors[`amount_${index}`];
      }

      return updatedErrors;
    });

    if (field === "amount") {
      setPurchaseOrderArr(updatedOrderArr);
      return;
    }

    const rate = parseFloat(updatedOrderArr[index].rate) || 0;
    const quantity = parseFloat(updatedOrderArr[index].quantity) || 0;
    const discount = parseFloat(updatedOrderArr[index].discount) || 0;
    const cgst = parseFloat(updatedOrderArr[index].cgst) || 0;
    const sgst = parseFloat(updatedOrderArr[index].sgst) || 0;

    const taxableAmount = Math.max(rate * quantity - discount, 0);
    const cgstAmount = (taxableAmount * cgst) / 100;
    const sgstAmount = (taxableAmount * sgst) / 100;
    const finalAmount = taxableAmount + cgstAmount + sgstAmount;

    updatedOrderArr[index].amount = finalAmount.toFixed(2);

    const grandTotal = updatedOrderArr
      .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)
      .toFixed(2);

    setPurchaseOrderArr(updatedOrderArr);

    setFormState((prev) => ({
      ...prev,
      grand_total: grandTotal,
    }));
  };

  const validateForm = () => {
    const errors = {};

    // Check required fields in formState
    if (!formState.suppliers) {
      errors.suppliers = "Supplier is required";
    }
    if (!formState.purchase_date) {
      errors.purchase_date = "Purchase date is required";
    }
    if (!formState.bill_type) {
      errors.bill_type = "Bill type is required";
    }
    if (!formState.bill_number) {
      errors.bill_number = "Bill number is required";
    }

    // if (!formState.grand_total || formState.grand_total <= 0) {
    //   errors.grand_total = "Grand total is required";
    // }

    // Validate each row in purchaseOrderArr

    // const filteredPurchaseOrderArr = purchaseOrderArr.filter((item) => {
    //   return !(
    //     !item.medicine_name &&
    //     !item.batch &&
    //     !item.expiry_date &&
    //     !item.quantity &&
    //     !item.cgst &&
    //     !item.sgst &&
    //     !item.amount
    //   );
    // });

    purchaseOrderArr?.forEach((item, index) => {
      if (!item?.medicine_name) {
        errors[`medicine_name_${index}`] = `Medicine is required`;
      }
      if (!item?.pack) {
        errors[`pack_${index}`] = `Pack is required `;
      }
      if (!item?.batch) {
        errors[`batch_${index}`] = `Batch is required `;
      }
      if (!item?.expiry_date) {
        errors[`expiry_date_${index}`] = `Expiry date is required`;
      }
      if (!item?.quantity || item.quantity <= 0) {
        errors[`quantity_${index}`] = `Quantity is Required`;
      }
      if (!item.cgst || item.cgst < 0) {
        errors[`cgst_${index}`] = `CGST is required`;
      }
      if (!item.sgst || item.sgst < 0) {
        errors[`sgst_${index}`] = `SGST is required`;
      }
      if (item?.amount < 0) {
        errors[`amount_${index}`] = `Amount is required`;
      }
    });

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    if (
      !formState?.supplier_id ||
      !formState?.bill_number ||
      !formState?.bill_type ||
      !formState.purchase_date
    ) {
      console.error("formState is undefined or empty!");
      return false;
    }
    return true;
  };

  // useEffect(() => {
  //   if (isFormValid() && !purchaseOrderResponse?.id && !focus) {
  //     if (!isSubmitting) {
  //       handleCreateOrder();
  //       setIsSubmitting(true);
  //     }
  //   }

  //   // console.log(isFormValid(), 'isFormValid' && !purchaseOrderResponse?.id, 'purchaseOrderResponse' && !focus, 'purchaseOrderResponse')
  //   // console.log(formState, 'formState');
  //   // console.log(purchaseOrderResponse, 'purchaseOrderResponse')
  //   // console.log(isFormValid(), !purchaseOrderResponse?.id, !focus, 'isFormValid !purchaseOrderResponse?.id')
  // }, [formState, purchaseOrderResponse, focus]);

  const handleCreateOrder = async () => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    setLoading(true);
    const payload = {
      purchase_order: {
        ...formState,
        department_id: "9",
        ...(purchaseOrderArr.length > 0 && {
          purchase_items_attributes: purchaseOrderArr.map(
            ({ medicine_name, ...rest }) => rest,
          ),
        }),
      },
    };
    try {
      const result = await generatePurchaseOrder(
        payload,
        // supplierData?.id
      );
      // console.log(result);
      if (result.status.status === "SUCCESS") {
        setPurchaseOrderResponse(result.payload);
        // console.log(result, 'result')
      }
      if (result.status.status === "SUCCESS") {
        showToast(
          "purchase order created successfully",
          result?.status?.status,
        );
        refetch();
        onClose();
      } else {
        showToast(
          result?.status?.message || result?.status?.status,
          result?.status?.status,
        );
      }
      // if (result?.status?.status === "SUCCESS") {
      //   showToast("Purchase Order Created  Successfully" ,"SUCCESS");
      //   // navigate("/admin/purchase_orders");
      // }
      setIsSubmitting(false);
      refetch();
    } catch (error) {
      showToast(error.message, "ERROR");
      setIsSubmitting(false);
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  // console.log(purchaseOrderArr, 'purchaseOrderArr')
  const handleUpdateOrder = async () => {
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }
    // e.preventDefault();
    setLoading(true);
    let itemsToDestroy = [];

    if (validateCorrectDeleteOrders?.length > 0) {
      const currentIds = purchaseOrderArr
        .map((item) => item?.id)
        .filter(Boolean);
      itemsToDestroy = validateCorrectDeleteOrders
        .filter((item) => !currentIds?.includes(item?.id))
        .map((item) => ({ ...item, _destroy: "1" }));
    }

    const payload = {
      purchase_order: {
        ...formState,
        department_id: "9",
        ...(purchaseOrderArr?.length > 0 || itemsToDestroy?.length > 0
          ? {
              purchase_items_attributes: [
                ...purchaseOrderArr?.map(({ medicine_name, ...rest }) => rest),
                ...itemsToDestroy,
              ],
            }
          : {}),
      },
    };
    try {
      const result = await putPurchaseOrder(payload, purchaseOrderResponse?.id);
      if (result?.status?.status === "SUCCESS") {
        setValidateCorrectDeleteOrders(
          result?.payload?.purchase_items?.map((item) => ({
            ...item,
            form_type: item?.medicine_form_type,
            flat_price: item?.medicine_flat_price,
          })),
        );
        setPurchaseOrderResponse(result.payload);

        const updatedItems =
          result?.payload?.purchase_items?.map((item) => ({
            ...item,
            form_type: item?.medicine_form_type,
            flat_price: item?.medicine_flat_price,
          })) || [];
        const newRow = {
          medicine_id: "",
          medicine_name: "",
          pack: "",
          hsn_code: "",
          batch: "",
          expiry_date: "",
          quantity: "",
          free_quantity: "",
          cgst: 2.5,
          sgst: 2.5,
          rate: "",
          mrp: "",
          mfr: "",
          discount: "",
          amount: "",
          department_id: "9",
        };
        setPurchaseOrderArr([...updatedItems, newRow]);
        showToast("Purchase Order Updated Successfully ", "SUCCESS");
        refetch();
        onClose();
        // handleAddRow();
      } else {
        showToast(
          result?.status?.message || result?.status?.status,
          result?.status?.status,
        );
      }
      setIsSubmitting(false);
    } catch (error) {
      showToast(error.message, "ERROR");
      setIsSubmitting(false);
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const hasAnyDataFilled = () => {
    // formState check (ignore default purchase_date)
    const formFilled =
      !!formState?.supplier_id ||
      !!formState?.suppliers ||
      !!formState?.bill_type ||
      !!formState?.bill_number ||
      (!!formState?.grand_total && Number(formState?.grand_total) > 0);

    // rows check: if any row has ANY meaningful value
    const rowFilled = (purchaseOrderArr || []).some((row) => {
      if (!row) return false;

      const keysToCheck = [
        "medicine_id",
        "medicine_name",
        "pack",
        "hsn_code",
        "batch",
        "expiry_date",
        "quantity",
        "free_quantity",
        "cgst",
        "sgst",
        "rate",
        "mrp",
        "mfr",
        "discount",
        "amount",
      ];

      return keysToCheck.some((k) => {
        const v = row[k];

        // number fields: > 0 or >=0 for tax etc (you can adjust)
        if (typeof v === "number") return v !== 0;

        // string fields
        if (typeof v === "string") return v.trim() !== "";

        // id objects etc
        return v !== null && v !== undefined && v !== "";
      });
    });

    return formFilled || rowFilled;
  };

  const handleRequestClose = () => {
    if (hasAnyDataFilled()) {
      setConfirmCloseOpen(true);
    } else {
      onClose();
    }
  };

  const handleConfirmClose = () => {
    setConfirmCloseOpen(false);
    onClose();
  };

  const handleCancelClose = () => {
    setConfirmCloseOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AddCardIcon
                sx={{
                  color: "neutral.navyBlue",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                New Purchase Order
              </Typography>
            </Box>
            <IconButton onClick={handleRequestClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Grid container spacing={1}>
            <Grid item sm={3}>
              <Autocomplete
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "8px",
                    border: "neutral.blackBorder", // Remove border
                  },
                  // "&:hover .MuiOutlinedInput-notchedOutline": {
                  //   border: "none", // Remove border on hover
                  //   borderRadius: "15px",
                  // },
                  // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  //   borderRadius: "15px",
                  //   border: "none", // Ensure border remains none on focus
                  // },
                  "& .MuiInputBase-input": {
                    padding: "2px 8px",
                  },
                  "& .MuiAutocomplete-inputRoot": {
                    padding: "2px 8px", // Remove extra padding around input
                  },
                  // padding:'0px',
                  borderRadius: "8px",
                  backgroundColor: "neutral.white",
                  "&:hover": {
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                  },
                }}
                options={fieldOptions?.supplierList || []}
                getOptionLabel={(option) => option.name || ""}
                value={
                  fieldOptions?.supplierList?.find(
                    (supplier) => supplier.id === formState.suppliers,
                  ) || null
                }
                onChange={(e, newValue) => {
                  handleFormChange({
                    target: {
                      name: "suppliers",
                      value: newValue ? newValue.id : "",
                    },
                  });
                  handleFormChange({
                    target: {
                      name: "supplier_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Supplier"
                    onChange={handleSupplierChange}
                    error={!!errors.suppliers}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {supplierListLoading ? (
                            <CircularProgress color="inherit" size={18} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <MenuItem
                    sx={{
                      ...menuItemStyle,
                      // "&:hover": {
                      //   backgroundColor: "#0067FF40 !important",
                      //   // borderRadius:"20%",
                      //   borderRadius: "16px",
                      //   color: "black !important",
                      // },
                    }}
                    {...props}
                    key={option.id}
                    value={option.id}
                  >
                    {option.name}
                  </MenuItem>
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
              {errors.suppliers && (
                <Typography color="error">{errors.suppliers}</Typography>
              )}
            </Grid>

            <Grid item sm={1.5}>
              <FormControl variant="outlined" sx={{ width: "100%" }}>
                <TextField
                  onFocus={() => setFocus(true)}
                  onBlur={() => setFocus(false)}
                  fullWidth
                  required
                  onChange={handleFormChange}
                  value={
                    formState?.purchase_date
                      ? formState?.purchase_date
                      : new Date().toISOString().split("T")[0]
                  }
                  type="date"
                  name="purchase_date"
                  label="Purchase date"

                  sx={autoFocusOffWithOutBorder}
                  error={!!errors.purchase_date}
                  helperText={errors.purchase_date}
                />
              </FormControl>
            </Grid>

            <Grid item sm={1.5}>
              <FormControl fullWidth variant="outlined">
                <Select
                  onFocus={() => setFocus(true)}
                  onBlur={() => setFocus(false)}
                  error={!!errors.billType}
                  required
                  fullWidth
                  sx={selectField}
                  value={formState?.bill_type}
                  onChange={handleFormChange}
                  name="bill_type"
                  displayEmpty
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "text.grey", opacity: "0.5" }}>
                          Bill Type
                        </span>
                      );
                    }
                    return selected === "credit"
                      ? "Credit"
                      : selected === "cash"
                        ? "Cash"
                        : "";
                  }}
                >
                  <MenuItem value="credit" sx={menuItemStyle}>
                    Credit
                  </MenuItem>
                  <MenuItem value="cash" sx={menuItemStyle}>
                    Cash
                  </MenuItem>
                  {/* <MenuItem value="other">Other</MenuItem> */}
                </Select>
                {errors.bill_type && (
                  <Typography color="error">{errors.bill_type}</Typography>
                )}
              </FormControl>
            </Grid>

            {/* Discount Type */}
            <Grid item sm={2}>
              <FormControl fullWidth variant="outlined">
                <Select
                  value={discountType}
                  onChange={(e) => {
                    const newType = e.target.value;
                    setDiscountType(newType);
                    setPurchaseOrderArr((prev) =>
                      prev.map((item) => {
                        const rate = parseFloat(item.rate) || 0;
                        const quantity = parseFloat(item.quantity) || 0;
                        const flatDiscount = parseFloat(item.discount) || 0;
                        if (newType === "percent") {
                          const subtotal = rate * quantity;
                          const percent =
                            subtotal > 0
                              ? ((flatDiscount / subtotal) * 100).toFixed(2)
                              : "";
                          return { ...item, discount_percent: percent };
                        }
                        return item;
                      }),
                    );
                  }}
                  sx={selectField}
                >
                  <MenuItem value="rs" sx={menuItemStyle}>
                    Discount in ₹
                  </MenuItem>
                  <MenuItem value="percent" sx={menuItemStyle}>
                    Discount in %
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item sm={2}>
              <TextField
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                fullWidth
                onChange={handleFormChange}
                value={formState?.bill_number}
                name="bill_number"
                placeholder="Bill number"
                // type="number"
                required
                variant="outlined"
                sx={{ ...autoFocusOffWithOutBorder }}
                error={!!errors.bill_number}
                helperText={errors.bill_number}
              />
            </Grid>

            <Grid item sm={2}>
              <TextField
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                fullWidth
                onChange={handleFormChange}
                value={formState?.grand_total}
                name="grand_total"
                placeholder="Grand Total"
                type="number"
                required
                variant="outlined"
                sx={{ ...autoFocusOffWithOutBorder }}
                // error={!!errors.grand_total}
                // helperText={errors.grand_total}
                // inputProps={{
                //   readOnly: true,
                // }}
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <TableContainer sx={{ mt: 2, width: "100%" }}>
              <Table sx={{ width: "100%" }}>
                <TableHead stickyHeader>
                  <TableRow sx={{ ...drTableGreen, textAlign: "center" }}>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        borderTopLeftRadius: "20px",
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                        width: "120px",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Medicine
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        paddingRight: "30px",
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Form Type
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        //  paddingX:"4px",
                        textAlign: "center",
                        width: "120px",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Pack{" "}
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        paddingRight: "30px",
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        HSN code
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Batch
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Expiry
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Quantity
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Free quantity
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        CGST{" "}
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        SGST
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Rate
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        MRP
                      </Typography>
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        MFR
                      </Typography>
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Discount
                      </Typography>
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body1_text_bold"
                        sx={{ color: "neutral.black" }}
                      >
                        Amount
                      </Typography>
                    </TableCell>
                    {/* <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.white",
                        p: "2px",
                        textAlign: "center",
                      }}
                    >
                      Department
                    </TableCell> */}

                    <TableCell
                      sx={{
                        p: "2px",
                        textAlign: "center",
                        borderTopRightRadius: "20px",
                      }}
                    >
                      <IconButton
                        onClick={handleAddRow}
                        sx={{
                          ...orangeButton,
                          marginLeft: "7px",
                          marginY: "2px",
                        }}
                      >
                        <AddIcon
                          sx={{
                            color: "neutral.white",
                            width: "30px",
                            height: "32px",
                            padding: "0px",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead>

                {purchaseOrderArr?.length > 0 ? (
                  <TableBody>
                    {purchaseOrderArr?.map((item, index) => (
                      <TableRow
                        sx={{
                          padding: "0px",
                          margin: "0px",
                          minWidth: "1000px",
                        }}
                      >
                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "200px",
                          }}
                        >
                          {
                            /*                           
                          <Autocomplete
                            options={filteredMedicines || []}
                            freeSolo
                            clearOnEscape={false}
                            // clearIcon={null}
                            open={openMedicineList === index}
                            onOpen={() => setOpenMedicines(index)}
                            onClose={() => setOpenMedicines(false)}
                            id={`medicine_name-${index}`}
                            inputValue={item?.medicine_name !== null ? item?.medicine_name : ""}
                            onInputChange={(e, value) => {
                              handleChange(index, "medicine_name", value, e);
                            }}
                            onChange={(e, value) => {
                              if (value) {
                                // console.log(value, 'value inside autocomplete ')
                                handleChange(index, "medicine_id", value[0]);
                                // handleChange(index, "medicine_name", value[1])
                                setTimeout(() => {
                                  document
                                    .getElementById(`pack-${index}`)
                                    .focus();
                                }, 0);
                              }
                            }}
                            sx={textfieldTextBlueBorderPharmacy}
                            PopperComponent={(props) => (
                              <Grid item lg={8}>
                                <Popper
                                  {...props}
                                  placement="bottom-start"
                                  style={menuItemStyle}
                                  modifiers={[
                                    {
                                      name: "preventOverflow",
                                      options: {
                                        boundary: "block",
                                      },
                                    },
                                  ]}
                                >
                                  <div
                                    style={{
                                      maxHeight: 300,
                                      overflowY: "auto",
                                      scrollbarWidth: "none",
                                      maxWidth: "320px",
                                      minWidth: "310px",
                                    }}
                                  >
                                    {props.children}
                                  </div>
                                </Popper>
                              </Grid>
                            )}
                            getOptionLabel={(option) => option[1]}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onChange={handleSearch}
                                value={searchTerm}
                                placeholder="Medicine"
                                error={!!errors[`medicine_name_${index}`]}
                                helperText={errors[`medicine_name_${index}`] || ""}
                                onKeyDown={(e) => handleKeyDown(e, index, "medicine_name")}
                              />
                            )}
                            renderOption={(props, option, { index }) => (
                              <MenuItem
                                sx={{
                                  ...menuItemStyle,
                                  "&:hover": {
                                    backgroundColor: "#0067FF40 !important",
                                    // borderRadius:"20%",
                                    borderRadius: "16px",
                                    color: "black !important",
                                  },
                                  ...(highlightedIndexMedicine === index && {
                                    backgroundColor: "#0067FF40 !important",
                                    color: "black !important",
                                    borderRadius: "16px",
                                  }),
                                }}
                                {...props}
                                key={option[0]}
                              >
                                {option[1]}
                              </MenuItem>
                            )}
                          /> */

                            <Autocomplete
                              options={filteredMedicines || []}
                              freeSolo
                              clearOnEscape={false}
                              // clearIcon={null}
                              open={openMedicineList === index}
                              onOpen={() => setOpenMedicines(index)}
                              onClose={() => setOpenMedicines(false)}
                              id={`medicine_name-${index}`}
                              inputValue={
                                item?.medicine_name !== null
                                  ? item?.medicine_name
                                  : ""
                              }
                              onInputChange={(e, value) => {
                                handleChange(index, "medicine_name", value);
                              }}
                              onChange={(e, value) => {
                                if (value) {
                                  console.log(value, "value on select");
                                  setSelectedMedicineId(value?.id);
                                  setSelectedMedicineIndex(index);
                                  const updatedOrderArr = [...purchaseOrderArr];
                                  updatedOrderArr[index] = {
                                    ...updatedOrderArr[index],
                                    medicine_id: value?.id,
                                    form_type: value?.form_type,
                                    flat_price: value?.flat_price,
                                  };
                                  setPurchaseOrderArr(updatedOrderArr);

                                  // handleChange(index, "medicine_id", value?.id);
                                  // handleChange(index, 'form_type', value?.form_type);
                                  // handleChange(index, 'flat_price', value?.flat_price);
                                  setTimeout(() => {
                                    document
                                      .getElementById(`pack-${index}`)
                                      .focus();
                                  }, 0);
                                }
                              }}
                              sx={textfieldTextBlueBorderPharmacy}
                              PopperComponent={(props) => (
                                <Grid item lg={8}>
                                  <Popper
                                    {...props}
                                    placement="bottom-start"
                                    style={menuItemStyle}
                                    modifiers={[
                                      {
                                        name: "preventOverflow",
                                        options: {
                                          boundary: "block",
                                        },
                                      },
                                    ]}
                                  >
                                    <div
                                      style={{
                                        maxHeight: 300,
                                        overflowY: "auto",
                                        scrollbarWidth: "none",
                                        maxWidth: "320px",
                                        minWidth: "310px",
                                      }}
                                    >
                                      {props.children}
                                    </div>
                                  </Popper>
                                </Grid>
                              )}
                              getOptionLabel={(option) => option?.name}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onChange={(e) => handleMedicineChange(e)}
                                  value={searchTerm}
                                  placeholder="Medicine"
                                  error={!!errors[`medicine_name_${index}`]}
                                  helperText={
                                    errors[`medicine_name_${index}`] || ""
                                  }
                                  onKeyDown={(e) =>
                                    handleKeyDown(e, index, "medicine_name")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {medicineLoading ? (
                                          <CircularProgress
                                            color="inherit"
                                            size={18}
                                          />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              renderOption={(props, option, { index }) => (
                                <MenuItem
                                  sx={{
                                    ...menuItemStyle,
                                    "&:hover": {
                                      backgroundColor: "#0067FF40 !important",
                                      // borderRadius:"20%",
                                      borderRadius: "16px",
                                      color: "black !important",
                                    },
                                    ...(highlightedIndexMedicine === index && {
                                      backgroundColor: "#0067FF40 !important",
                                      color: "black !important",
                                      borderRadius: "16px",
                                    }),
                                  }}
                                  {...props}
                                  key={option?.id}
                                >
                                  {option?.name}
                                </MenuItem>
                              )}
                            />
                          }
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "90px",
                          }}
                        >
                          <TextField
                            placeholder="Form Type"
                            value={item?.form_type}
                            id={`form-type-${index}`}
                            disabled={true}
                            // onKeyDown={(e) => handleKeyDown(e, index, "hsnCode")}
                            sx={{ ...textfieldTextBlueBr }}
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "120px",
                          }}
                        >
                          <Autocomplete
                            // freeSolo
                            clearOnEscape={false}
                            clearIcon={null}
                            id={`pack-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "pack")}
                            sx={{
                              ...textfieldTextBlueBorder,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                height: "40px",
                                padding: "9px !important",
                                "& input": {
                                  padding: "8px",
                                  fontSize: "14px",
                                },
                                "& .MuiAutocomplete-popupIndicator": {
                                  display: "none", // Hides the dropdown icon
                                },
                              },
                            }}
                            options={
                              fieldOptions?.packList?.filter(
                                (option) => option,
                              ) || []
                            } // Filter out invalid entries
                            getOptionLabel={(option) => option || ""} // Use the string value directly
                            value={item?.pack || ""}
                            // onInputChange={(e, value) => {
                            //   if (value || value === "") {
                            //     handleChange(index, "pack", value);
                            //   }
                            // }}
                            onChange={(e, value) => {
                              if (value) {
                                handleChange(index, "pack", value || "");
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Pack"
                                error={!!errors[`pack_${index}`]}
                                helperText={errors[`pack_${index}`] || ""}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment:
                                    medicineDetailsLoading &&
                                    selectedMedicineIndex === index ? (
                                      <InputAdornment position="end">
                                        <CircularProgress size={14} />
                                      </InputAdornment>
                                    ) : (
                                      params.InputProps.endAdornment
                                    ),
                                }}
                              />
                            )}
                            renderOption={(props, option) => (
                              <MenuItem {...props} key={option}>
                                {option}
                              </MenuItem>
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            } // Compare values directly
                          />
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "90px",
                          }}
                        >
                          <TextField
                            placeholder="HSN code"
                            value={item?.hsn_code}
                            id={`hsnCode-${index}`}
                            onChange={(e) => {
                              handleChange(index, "hsn_code", e.target.value);
                            }}
                            onKeyDown={(e) =>
                              handleKeyDown(e, index, "hsnCode")
                            }
                            sx={{ ...textfieldTextBlueBr }}
                            InputProps={{
                              endAdornment:
                                medicineDetailsLoading &&
                                selectedMedicineIndex === index ? (
                                  <InputAdornment position="end">
                                    <CircularProgress size={14} />
                                  </InputAdornment>
                                ) : null,
                            }}
                          />
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "90px",
                          }}
                        >
                          <TextField
                            placeholder="Batch"
                            sx={textfieldTextBlueBr}
                            value={item?.batch}
                            id={`batch-${index}`}
                            onChange={(e) => {
                              handleChange(index, "batch", e.target.value);
                            }}
                            onKeyDown={(e) => handleKeyDown(e, index, "batch")}
                            error={!!errors[`batch_${index}`]}
                            helperText={errors[`batch_${index}`] || ""}
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            placeholder="EXP"
                            sx={textfieldTextBlueBr}
                            value={item?.expiry_date}
                            inputProps={{
                              min: new Date().toISOString().split("T")[0],
                            }}
                            // label="Expiry date"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            id={`expiry_date-${index}`}
                            onChange={(e) => {
                              handleChange(
                                index,
                                "expiry_date",
                                e.target.value,
                              );
                            }}
                            onKeyDown={(e) =>
                              handleKeyDown(e, index, "expiry_date")
                            }
                            type="date"
                            error={!!errors[`expiry_date_${index}`]}
                            helperText={errors[`expiry_date_${index}`] || ""}
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "90px",
                          }}
                        >
                          <TextField
                            value={item?.quantity}
                            id={`quantity-${index}`}
                            onChange={(e) => {
                              handleChange(index, "quantity", e.target.value);
                            }}
                            onKeyDown={(e) =>
                              handleKeyDown(e, index, "quantity")
                            }
                            placeholder="Quantity"
                            sx={textfieldTextBlueBr}
                            type="number"
                            error={!!errors[`quantity_${index}`]}
                            helperText={errors[`quantity_${index}`] || ""}
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "90px",
                          }}
                        >
                          <TextField
                            value={item?.free_quantity}
                            id={`free_quantity-${index}`}
                            onChange={(e) => {
                              handleChange(
                                index,
                                "free_quantity",
                                e.target.value,
                              );
                            }}
                            onKeyDown={(e) =>
                              handleKeyDown(e, index, "free_quantity")
                            }
                            placeholder="Free quantity"
                            sx={textfieldTextBlueBr}
                            type="number"
                            error={!!errors[`free_quantity${index}`]}
                            helperText={errors[`free_quantity${index}`] || ""}
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "80px",
                          }}
                        >
                          <TextField
                            value={item?.cgst}
                            onChange={(e) => {
                              handleChange(index, "cgst", e.target.value);
                            }}
                            id={`cgst-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "cgst")}
                            placeholder="CGST"
                            sx={textfieldTextBlueBr}
                            type="number"
                            error={!!errors[`cgst_${index}`]}
                            helperText={errors[`cgst_${index}`] || ""}
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            minWidth: "80px",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            value={item?.sgst}
                            onChange={(e) => {
                              handleChange(index, "sgst", e.target.value);
                            }}
                            placeholder="SGST"
                            id={`sgst-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "sgst")}
                            sx={textfieldTextBlueBr}
                            type="number"
                            error={!!errors[`sgst_${index}`]}
                            helperText={errors[`sgst_${index}`] || ""}
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            minWidth: "80px",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            value={item?.rate}
                            onChange={(e) => {
                              handleChange(index, "rate", e.target.value);
                            }}
                            placeholder="Rate"
                            id={`rate-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "rate")}
                            sx={textfieldTextBlueBr}
                            type="number"
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "80px",
                          }}
                        >
                          <TextField
                            value={item?.mrp}
                            onChange={(e) => {
                              handleChange(index, "mrp", e.target.value);
                            }}
                            placeholder="MRP"
                            sx={textfieldTextBlueBr}
                            id={`mrp-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "mrp")}
                            type="number"
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "80px",
                          }}
                        >
                          <TextField
                            value={item?.mfr}
                            onChange={(e) => {
                              handleChange(index, "mfr", e.target.value);
                            }}
                            placeholder="MFR"
                            id={`mfr-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "mfr")}
                            sx={textfieldTextBlueBr}
                          ></TextField>
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "115px",
                          }}
                        >
                          <TextField
                            value={
                              discountType === "percent"
                                ? item?.discount_percent || ""
                                : item?.discount || ""
                            }
                            onChange={(e) =>
                              handleChange(index, "discount", e.target.value)
                            }
                            id={`discount-${index}`}
                            onKeyDown={(e) =>
                              handleKeyDown(e, index, "discount")
                            }
                            placeholder={
                              discountType === "percent" ? "%" : "Discount"
                            }
                            sx={textfieldTextBlueBr}
                            type="number"
                            InputProps={{
                              endAdornment:
                                discountType === "percent" &&
                                item?.discount_percent ? (
                                  <InputAdornment position="end">
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: "text.secondary",
                                        fontSize: "11px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      ₹
                                      {parseFloat(item?.discount || 0).toFixed(
                                        2,
                                      )}
                                    </Typography>
                                  </InputAdornment>
                                ) : null,
                            }}
                          />
                        </TableCell>

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "90px",
                          }}
                        >
                          <TextField
                            value={item?.amount}
                            onChange={(e) => {
                              handleChange(index, "amount", e.target.value);
                            }}
                            id={`amount-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "amount")}
                            placeholder="Amount"
                            sx={textfieldTextBlueBr}
                            type="number"
                            error={!!errors[`amount_${index}`]}
                            helperText={errors[`amount_${index}`] || ""}
                            inputProps={{
                              readOnly: !!item?.flat_price,
                            }}
                          ></TextField>
                          {item?.flat_price && (
                            <Typography
                              variant="caption"
                              sx={{
                                color: "orange",
                                mt: "2px",
                                display: "block",
                              }}
                            >
                              Flat Price: ₹{item?.flat_price}
                            </Typography>
                          )}
                        </TableCell>

                        {/* <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "70px",
                          }}
                        >
                          <TextField
                            value={item?.department_id}
                            inputProps={{ readOnly: true }}
                            onChange={(e) => {
                              handleChange(index, "department_id", e.target.value);
                            }}
                            id={`department_id-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "department_id")}
                            placeholder="Department"
                            sx={textfieldTextBlueBr}
                          ></TextField>
                        </TableCell> */}

                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            borderTopLeftRadius: "20px",
                            color: "neutral.white",
                            p: "2px",
                            textAlign: "center",
                            minWidth: "70px",
                          }}
                        >
                          <IconButton
                            sx={{ marginLeft: "2px", marginBottom: "7px" }}
                            onClick={() => handleDeleteRow(index)}
                          >
                            <CloseIcon
                              sx={{
                                ...xBtn,
                                width: "28px",
                                height: "28px",
                                borderRadius: "50%",
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableRow>
                    {/* <TableCell sx={{
                      textAlign: "center",
                    }}
                      colSpan={15}>
                      <Typography color={"black"} variant="heading2">
                        No data
                      </Typography> </TableCell> */}
                  </TableRow>
                )}
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        <Box
          container
          display={"flex"}
          justifyContent={"space-between"}
          sx={{ zIndex: "10" }}
          lg={12}
          marginBottom={"5px"}
        >
          <Grid item>
            {purchaseOrderArr.length > 0 &&
              (() => {
                const totals = purchaseOrderArr.reduce(
                  (acc, item) => {
                    const rate = parseFloat(item.rate) || 0;
                    const quantity = parseFloat(item.quantity) || 0;
                    const discount = parseFloat(item.discount) || 0;
                    const cgst = parseFloat(item.cgst) || 0;
                    const sgst = parseFloat(item.sgst) || 0;
                    const taxable = Math.max(rate * quantity - discount, 0);
                    acc.subtotal += rate * quantity;
                    acc.discount += discount;
                    acc.taxable += taxable;
                    acc.cgst += (taxable * cgst) / 100;
                    acc.sgst += (taxable * sgst) / 100;
                    return acc;
                  },
                  { subtotal: 0, discount: 0, taxable: 0, cgst: 0, sgst: 0 },
                );
                const totalGST = totals.cgst + totals.sgst;
                const grandTotal = Math.round(totals.taxable + totalGST);
                return (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 3,
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="caption" color="text.secondary">
                        Sub Total
                      </Typography>
                      <Typography variant="body1_text_bold" display="block">
                        ₹{totals.subtotal.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="caption" color="text.secondary">
                        Total Discount
                      </Typography>
                      <Typography
                        variant="body1_text_bold"
                        display="block"
                        sx={{ color: "error.main" }}
                      >
                        −₹{totals.discount.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="caption" color="text.secondary">
                        Taxable Amount
                      </Typography>
                      <Typography variant="body1_text_bold" display="block">
                        ₹{totals.taxable.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="caption" color="text.secondary">
                        CGST
                      </Typography>
                      <Typography variant="body1_text_bold" display="block">
                        ₹{totals.cgst.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="caption" color="text.secondary">
                        SGST
                      </Typography>
                      <Typography variant="body1_text_bold" display="block">
                        ₹{totals.sgst.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        textAlign: "center",
                        borderLeft: "2px solid",
                        borderColor: "divider",
                        pl: 2,
                      }}
                    >
                      <Typography variant="caption" color="text.secondary">
                        Total GST
                      </Typography>
                      <Typography
                        variant="body1_text_bold"
                        display="block"
                        sx={{ color: "neutral.navyBlue" }}
                      >
                        ₹{totalGST.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        textAlign: "center",
                        borderLeft: "2px solid",
                        borderColor: "divider",
                        pl: 2,
                      }}
                    >
                      <Typography variant="caption" color="text.secondary">
                        Grand Total
                      </Typography>
                      <Typography
                        variant="body1_text_bold"
                        display="block"
                        sx={{ color: "neutral.navyBlue" }}
                      >
                        ₹{grandTotal}
                      </Typography>
                    </Box>
                  </Box>
                );
              })()}
          </Grid>

          <Grid item>
            {purchaseOrderResponse?.id ? (
              <Button
                onClick={handleUpdateOrder}
                className="btn draw-border"
                variant="contained"
                id="submit"
                sx={{
                  ...primaryBtnTeal,
                  width: "195px",
                  display: "flex",

                  alignItems: "center",
                  justifyContent: "center",
                }}
                disabled={loading}
              >
                <Typography
                  textTransform={"capitalize"}
                  color={"neutral.white"}
                  variant="title1_medium"
                >
                  Update Order
                </Typography>
              </Button>
            ) : (
              <Button
                onClick={handleCreateOrder}
                className="btn draw-border"
                variant="contained"
                id="submit"
                sx={{
                  ...primaryBtnTeal,
                  width: "195px",
                  display: "flex",

                  alignItems: "center",
                  justifyContent: "center",
                }}
                disabled={loading}
              >
                <Typography
                  textTransform={"capitalize"}
                  color={"neutral.white"}
                  variant="title1_medium"
                >
                  Create Order
                </Typography>
              </Button>
            )}
          </Grid>
        </Box>
      </Box>
      <Dialog
        open={confirmCloseOpen}
        onClose={handleCancelClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Discard changes?</DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to close? You will lose all your data.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancelClose} variant="outlined">
            No
          </Button>
          <Button
            onClick={handleConfirmClose}
            variant="contained"
            color="error"
          >
            Yes, Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewPurchaseOrder;
